import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffc978] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0f0f2d] disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-[#ffc978] text-[#0f0f2d] hover:bg-[#ffd699] shadow-lg shadow-[#ffc978]/20',
    secondary: 'bg-[#1a1a3e] text-white hover:bg-[#252550] border border-[#2a2a5a]',
    outline: 'bg-transparent border-2 border-[#ffc978] text-[#ffc978] hover:bg-[#ffc978]/10',
    ghost: 'bg-transparent text-[#8b8bab] hover:text-white hover:bg-[#1a1a3e]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-50">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-51" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-52">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-53">{rightIcon}</span>}
    </motion.button>;
}